export { TabsComponent } from './tabs.component';
